import { Link } from "react-router-dom";
import { Wordmark } from "./Wordmark";

interface Props {
  current?: "home" | "send" | "claim" | "feed" | "board" | "auction" | "x402";
}

export function Nav({ current }: Props) {
  const linkCls = (active: boolean) =>
    `min-h-11 inline-flex items-center px-2.5 sm:px-3 py-1.5 rounded-md transition-[color,background-color,transform] active:scale-[0.96] ${
      active ? "text-ink bg-paper-deep" : "text-muted hover:text-ink"
    }`;
  return (
    <nav className="w-full px-4 py-4 sm:px-6 sm:py-5 md:px-10 md:py-7 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 justify-between">
      <Wordmark size="md" href="/" />
      <div className="w-full sm:w-auto flex flex-wrap items-center gap-0.5 sm:gap-1 text-sm">
        <Link to="/send" aria-current={current === "send" ? "page" : undefined} className={linkCls(current === "send")}>
          Send
        </Link>
        <Link to="/x402" aria-current={current === "x402" ? "page" : undefined} className={linkCls(current === "x402")}>
          Services
        </Link>
        <Link to="/claim" aria-current={current === "claim" ? "page" : undefined} className={linkCls(current === "claim")}>
          Claim
        </Link>
        <Link to="/board" aria-current={current === "board" ? "page" : undefined} className={linkCls(current === "board")}>
          Board
        </Link>
        <a
          href="https://docs.boonprotocol.com/skill.md"
          className="hidden md:inline-flex px-3 py-1.5 rounded-md text-muted hover:text-ink transition-colors btn-mono"
          target="_blank"
          rel="noopener noreferrer"
        >
          ↗ skill.md
        </a>
      </div>
    </nav>
  );
}
